import Route from '@ember/routing/route';

export default class AuthenticatedIdrRecommendationsRoute extends Route {
  queryParams = {
    recommendation: { refreshModel: false, replace: false },
  };
}
